import { Link } from "react-router-dom";
import { CONTACT, NAV_LINKS } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-warm">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 py-20 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="inline-block bg-warm px-5 py-4">
              <img src="/hm-beacon-logo.png" alt="HM Beacon" className="h-8 w-auto" />
            </div>
            <p className="mt-8 font-heading font-light text-2xl md:text-3xl leading-snug max-w-md text-warm/90">
              Building Authority Through Strategic Visibility.
            </p>
            <p className="mt-6 text-sm text-warm/55 font-body">
              Strategic Visibility Partner
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="overline text-gold mb-6">Navigate</p>
            <ul className="space-y-3">
              <li><Link to="/" className="text-warm/70 hover:text-warm transition-colors">Home</Link></li>
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-warm/70 hover:text-warm transition-colors" data-testid={`footer-link-${l.to.replace("/", "")}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-gold mb-6">Contact</p>
            <ul className="space-y-3 text-warm/70">
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-warm transition-colors" data-testid="footer-email">{CONTACT.email}</a></li>
              <li><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-warm transition-colors" data-testid="footer-phone">{CONTACT.phone}</a></li>
              <li className="pt-4 leading-relaxed">
                {CONTACT.officeName}<br />
                {CONTACT.officeLines.map((line) => <span key={line}>{line}<br /></span>)}
              </li>
            </ul>
          </div>
        </div>

        <div className="py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-warm/50">
          <p>© {new Date().getFullYear()} HM Beacon. All rights reserved.</p>
          <p className="max-w-xl leading-relaxed">Visibility is not the destination. Authority is.</p>
        </div>
      </div>
    </footer>
  );
}
